// extracted by mini-css-extract-plugin
export var paginationCurrent = "index-module--pagination-current--89d3b";
export var thumbsSwiper = "index-module--thumbs-swiper--4a664";